import { render, staticRenderFns } from "./BubbleArea.vue?vue&type=template&id=5ef2b570&scoped=true"
import script from "./BubbleArea.vue?vue&type=script&lang=js"
export * from "./BubbleArea.vue?vue&type=script&lang=js"
import style0 from "./BubbleArea.vue?vue&type=style&index=0&id=5ef2b570&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef2b570",
  null
  
)

export default component.exports